/** Backend and filters use Application Complete. Application Completed is a legacy label only. */
export const normalizeAdmissionStatusLabel = (status) =>
  status === "Application Completed" ? "Application Complete" : status;

export const STATUS_BADGE_COLORS = {
  "Incomplete Application": "bg-yellow-100 text-yellow-800",
  "Offer Letter Applied": "bg-blue-100 text-blue-800",
  "Offer Letter Received": "bg-indigo-100 text-indigo-800",
  "GS Documents Submitted": "bg-purple-100 text-purple-800",
  "Offer Letter Signed": "bg-orange-100 text-orange-800",
  "COE Applied": "bg-teal-100 text-teal-800",
  "COE Received": "bg-green-100 text-green-800",
  "Application Complete": "bg-emerald-100 text-emerald-900",
  "Application Withdraw": "bg-red-100 text-red-800",
};

const AdmissionStatusBadge = ({ status }) => {
  const label = normalizeAdmissionStatusLabel(status);
  const color = STATUS_BADGE_COLORS[label] || "bg-app-surface-muted text-app-text";
  return (
    <span className={`px-2.5 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${color}`}>
      {label || "—"}
    </span>
  );
};

export default AdmissionStatusBadge;
